module.exports = __webpack_public_path__ + "media/images/gradient-9ebc10dc18d3c6b1e579d16c084fe71c.png";